import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { Utils } from '@ortho-next/nextray-core';
import { AnatomicalSideLabelPipe, BaseMaLtTableComponent } from '../../shared';


/**
* Table of correction measures for Lateral image.
*/
@Component({
	selector: 'ma-lt-recap',
	templateUrl: './ma-lt-recap.component.html',
	imports: [
		NgbCollapseModule,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class MaLtRecapComponent extends BaseMaLtTableComponent {

	isCollapsed = true;

	// VALIDATION

	/**
	* Check if PDFA value is valid.
	*/
	get isValidPDFA(): boolean {
		return !this.eocMeasures?.eoc_lt_PDFA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_lt_PDFA, this.ltAngles.PDFA);
	}

	/**
	* Check if Knee Translation value is valid.
	*/
	get isValidKneeTransl(): boolean {
		return !this.eocMeasures?.eoc_lt_kneeTranslation || Utils.isPaleyAngleValid(this.eocMeasures.eoc_lt_kneeTranslation, this.ltAngles.KneeTransl);
	}

	/**
	* Check if PPTA value is valid.
	*/
	get isValidPPTA(): boolean {
		return !this.eocMeasures?.eoc_lt_PPTA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_lt_PPTA, this.ltAngles.PPTA);
	}

	/**
	* Check if ADTA value is valid.
	*/
	get isValidADTA(): boolean {
		return !this.eocMeasures?.eoc_lt_ADTA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_lt_ADTA, this.ltAngles.ADTA);
	}

	/**
	* Check if a measure is out of range.
	*/
	get isMeasureOutOfRange(): boolean {
		return !this.isValidPDFA || !this.isValidKneeTransl || !this.isValidPPTA || !this.isValidADTA;
	}

}
